const messages = {
  units: {
    points: "b.",
    piecesCount: "{count} ks.",
    piecesCountUnit: "ks.",
  },
  account: {
    title: "Stav účtu",
    noPointsYet: "Zatím žádné body",
    loading: "Načítání stavu účtu…",
    lastUpdate: "Poslední aktualizace: {date}",
    toggleToPurchases: "Zobrazit vaše nákupy",
    toggleToFirstStop: "Zobrazit stav účtu First Stop",
    firstStopPanelButton: "Panel First Stop",
  },
  purchases: {
    title: "VAŠE NÁKUPY",
    carMinimum: "min. 20 ks.",
    busMinimum: "min. 12 ks.",
    bikeMinimum: "min. 10 ks.",
    detailsButton: "Podrobnosti nákupů",
  },
  quickLinks: {
    rules: {
      title: "Pravidla Vášně",
      subtitle: "a tabulka příplatků",
    },
    promotions: {
      title: "Časově omezené akce",
      subtitle: "a speciální kampaně",
    },
    knowledge: {
      title: "BRIDGESTONE Go",
      subtitle: "Znalosti a odměny",
    },
  },
  bonusUhrd: {
    title: "Bonus UHRD",
    pointsLabel: "+75 b.",
    goalLabel: "Váš cíl: {count} ks.",
    goalAchievedLabel: "Cíl dosažen: {count} ks.",
    beyondGoalPointsLabel: "+15 b.",
    beyondGoalPointsPerUnit: "/ks.",
    beyondGoalTotalPointsLabel: "+180",
    beyondGoalTotalPointsUnit: "b.",
    mockGoalAchievedToggle: "Mock: cíl dosažen",
    detailsButton: "Zjistěte podrobnosti bonusu",
    regsButton: "Pravidla",
  },
  bonusUhrdPage: {
    crumbHome: "Domů",
    crumbBonus: "Bonus UHRD",
    heroHeadline: "Získej bonusové body za velká kola",
    goalReminderEyebrow: "UŽ POSLEDNÍ METR",
    goalReminderDaysLeftLead: "Zbývá vám ještě: ",
    goalReminderDaysLeftEmphasis: "{days} dní",
    bonusPeriodLine: "Platnost akce: 01.01.2026 – 31.12.2026",
    periodLead: "Platnost akce:",
    periodDates: "01.01.2026 – 31.12.2026",
    rulesHeading: "PRAVIDLA JEDNODUCHÁ",
    rules: {
      passengerTyres: {
        title: "KUPIUJTE PNEUMATIKY UHRD",
        description:
          "Bonusové body získáte za nákup osobních pneumatik 18” a větších.",
      },
      achieveAdv: {
        title: "DOSÁHNĚTE SVÉHO CÍLE",
        points: "+75 b.",
        description: "Dosáhnete-li svého cíle, získáte první bonus:",
      },
      challengeAdv: {
        title: "JEŠTĚ VÍCE BODŮ!",
        description:
          "Za každou pneumatiku nad cílem získáte +15 b. (maximálně +10 000 b.!)",
      },
      rewardsHighlighted: {
        title: "ODMĚNY ZA BODY",
        description:
          "Nasbírané body lze měnit za odměny z katalogu Bridgestone dle doběhu programu.",
      },
    },
  },
  bonusGoals: {
    title: "Nákupní cíle",
  },
  bonusGoalsPage: {
    crumbHome: "Domů",
    crumbBonus: "Nákupní cíle",
    heroHeadline: "Plňte nákupní cíle a sbírejte prémiové body",
    goalReminderEyebrow: "UŽ POSLEDNÍ METR",
    goalReminderDaysLeftLead: "Zbývá vám ještě: ",
    goalReminderDaysLeftEmphasis: "{days} dní",
    bonusPeriodLine: "Platnost akce: 01.01.2026 – 31.12.2026",
    rulesHeading: "PRAVIDLA JEDNODUCHÁ",
    rules: {
      passengerTyres: {
        title: "BODY ZA SPLNĚNÍ CÍLŮ",
        description:
          "Kategorie a výše progrese jsou uvedeny v komunikaci kampaně a doplňkovém dokumentu.",
      },
      achieveAdv: {
        title: "PRVNÍ STUPEN",
        points: "+2 000 b.",
        description:
          "Po dosažení prvního výkonnostního pásma vzniká nárok na bonus:",
      },
      challengeAdv: {
        title: "VYŠŠÍ STUPEN",
        points: "+3 000 b.",
        description:
          "Druhá hranice vám navyše přidělí další prémiové body dle komunikovaných podmínek:",
      },
      rewardsHighlighted: {
        title: "ODMĚNY ZA BODY",
        description:
          "Nasbírané body měníte za odměny v katalogu Bridgestone dle doběhu programu.",
      },
    },
  },
  bonusAwansPage: {
    crumbHome: "Domů",
    crumbBonus: "BONUS ZA POSTUP",
    heroHeadline: "Překonávejte nákupní prahy — získejte další prémiové body",
    goalReminderEyebrow: "UŽ POSLEDNÍ METR",
    goalReminderEyebrowRemaining: "Ještě jen",
    goalReminderDaysLeftLead: "Zbývá vám ještě: ",
    goalReminderDaysLeftEmphasis: "{days} dní",
    bonusPeriodLine: "Platnost akce: 01.01.2026 – 31.12.2026",
    periodLead: "Platnost akce: ",
    periodDates: "01.01.2026 - 31.12.2026",
    periodNote: ". Bonusy se nesčítají — obdržíte nejvyšší dosažený.",
    rulesHeading: "PRAVIDLA JEDNODUCHÁ",
    rules: {
      passengerTyres: {
        title: "REALIZUJTE NÁKUPY V PROGRAMU",
        description:
          "Postup se počítá podle platné komunikace kampaně a tabulky doplatků Bridgestone.",
      },
      achieveAdv: {
        title: "PRVNÍ PRÁH POSTUPU",
        points: "+2 000 b.",
        description:
          "Po dosažení prvního limitu kusů vzniká nárok na prémiové body za postup podle edice:",
      },
      challengeAdv: {
        title: "VYŠŠÍ PRÁH POSTUPU",
        points: "+3 000 b.",
        description:
          "Další práh přiděluje další bonusové body podle podmínek kampaně:",
      },
      rewardsHighlighted: {
        title: "ODMĚNY ZA BODY",
        description:
          "Nasbírané body měníte za odměny z katalogu po uzavření období.",
      },
    },
  },
  bonusAwans: {
    title: "BONUS ZA POSTUP",
    detailsButton: "Zjistěte podrobnosti bonusu",
    mockFirstMilestoneAchievedToggle: "Mock: první práh dosažen",
    milestones: {
      goal: {
        pointsLabel: "+2000 b.",
        label: "Váš cíl: 200 ks.",
        achievedLabel: "Cíl dosažen: {count} ks.",
      },
      challenge: {
        pointsLabel: "+3000 b.",
        label: "zvládnete to? 400 ks.",
        remainingLabel: "Ještě jen {count} ks.",
      },
    },
  },
  analytics: {
    pointsVsLastYear: {
      title: "Získané body vs. minulý rok",
    },
    tiresVsLastYear: {
      title: "Objednané pneumatiky vs. minulý rok",
    },
    purchasesByInch: {
      title: "Nákupy podle palce",
    },
    purchasesBySupplier: {
      title: "Nákupy podle velkoobchodníka",
    },
    view: {
      chart: "Graf",
      table: "Tabulka",
    },
    legend: {
      lastYear: "minulý rok",
      thisYear: "tento rok",
    },
    tireType: "Typ pneumatiky",
    tireTypes: {
      all: "Vše",
      passenger: "Osobní",
      truck: "Nákladní",
    },
    downloadXls: "Stáhnout .xls",
    table: {
      month: "Měsíc",
      label: "Kategorie",
      percent: "Podíl %",
    },
    months: {
      jan: "led",
      feb: "úno",
      mar: "bře",
      apr: "dub",
      may: "kvě",
      jun: "čvn",
      jul: "čvc",
      aug: "srp",
      sep: "zář",
      oct: "říj",
      nov: "lis",
      dec: "pro",
    },
    inch: {
      15: '15"',
      16: '16"',
      17: '17"',
      18: '18"',
      19: '19"',
      20: '20"',
    },
    suppliers: {
      interCars: "Inter Cars",
      handlopex: "Handlopex",
      latex: "Latex",
    },
    surchargeTable: {
      title: "Tabulka příplatků",
      diameterHeader: "Průměr pneumatiky",
      andMore: "a více",
      note1:
        "Tabulka ukazuje počet bodů udělených za nákup 1 ks pneumatiky podle značky a průměru.",
      note2: "Body se aktivují po dosažení minimálního počtu kusů.",
      rulesButton: "Zkontrolovat pravidla",
    },
  },
  promotions: {
    heading:
      "Využijte všechny akce a sbírejte maximální počet bodů!",
    pageBrandLabel: "Bridgestone Plus",
    pageTitle: "Akce",
    pageIntro:
      "Prohlédněte si všechny aktivní akce, přihlaste se k těm, které to vyžadují, a maximalizujte body za nákup pneumatik.",
    pageListHeading: "Všechny dostupné akce",
    filtersAriaLabel: "Filtrovat akce",
    filterAll: "Vše",
    filterActive: "Aktivní",
    filterSignInRequired: "Vyžaduje přihlášení",
    filterSigned: "Přihlášeno",
    viewAll: "Zobrazit všechny akce",
    detailsLink: "Detail akce",
    backToHome: "Zpět na úvodní stránku",
    backToList: "Zpět na seznam akcí",
    loading: "Načítání akcí…",
    listView: "Zobrazení seznamu",
    sliderView: "Zobrazení posuvníku",
    cardButton: "Využít akci",
    signInButton: "Přihlásit se k akci",
    signedInButton: "Přihlášeno k akci",
    signInSuccess: "Byli jste přihlášeni k akci.",
    signInError: "Přihlášení k akci se nezdařilo. Zkuste to znovu.",
    detailDescriptionTitle: "Popis akce",
    detailRulesTitle: "Pravidla",
    detailRelatedTitle: "Další akce",
    detailRewardLabel: "Odměna",
    detailInfoTitle: "Informace",
    detailInfoStatus: "Stav",
    detailInfoStart: "Začátek",
    detailInfoEnd: "Konec",
    detailInfoBonus: "Bonus",
    detailHelpTitle: "Potřebujete pomoc?",
    detailHelpText:
      "Máte dotazy k této akci? Kontaktujte nás.",
    detailHelpContact: "Kontakt",
    detailNoDescription: "Popis akce není k dispozici.",
    detailPeriod: "Období akce: {start} – {end}",
    detailAutoApply: "Body se připisují automaticky po nákupu.",
    detailNotFound: "Akce nebyla nalezena.",
    stats: {
      total: "Celkem",
      active: "Aktivní",
      signInRequired: "Vyžaduje přihlášení",
    },
    status: {
      active: "Aktivní",
      ending_soon: "Brzy končí",
      planned: "Připravujeme",
    },
    pointsLabel: {
      multiply: "x{value} více bodů",
      add: "+{value} bodů za každou pneumatiku!",
    },
    items: {
      default: {
        description:
          "V letošní edici Bridgestone Vášně je až 120 odměn. Stav vašeho účtu vám umožňuje uplatnit až 88 z nich!",
      },
      doublePoints: {
        title: "Dvojnásobné body za pneumatiky řady Ecopia Elite 60",
        pointsLabel: "x2 více bodů",
      },
      purchaseGoal: {
        title: "Extra body za splnění nákupního cíle",
        pointsLabel: "+1 bod za každou pneumatiku!",
      },
    },
  },
  rewards: {
    catalogView: "Zobrazení katalogu",
    sliderView: "Zobrazení posuvníku",
    slidesAriaLabel: "Snímky katalogu odměn",
    showSlideAriaLabel: "Zobrazit snímek {number}",
    claimButton: "Vyzvednout odměnu",
    catalogTitle: "Prohlédněte si celý KATALOG odměn",
    catalogDescriptionStart:
      "Letos máme až 120 odměn. Aktuální stav účtu vám umožňuje uplatnit",
    catalogDescriptionEnd: "z nich!",
    exchangeButton: "Vyměňte body za odměny",
    slides: {
      race: {
        title: "Odměna týdne: den na závodní dráze",
        description:
          "Usedněte za volant tisícikoňového rally monstra. Plyn v podlaze a... START!",
        points: "1400 b.",
      },
      voucher: {
        title: "Oblíbená odměna: poukaz do Media Expert",
        description:
          "Telefon? Televize? Něco na zahradu nebo na terasu? Vyměňte body za skvělé nákupy!",
        points: "od 500 b.",
      },
    },
  },
  benefits: {
    headingStart: "Využijte",
    headingHighlight: "všechny",
    headingEnd: "výhody od Bridgestone:",
    tabs: {
      myApps: "Moje aplikace",
      allApps: "Všechny aplikace",
    },
    emptyMyApps:
      "Zatím nemáte přiřazené aplikace. Přepněte na „Všechny aplikace“ a požádejte o přístup.",
    openButton: "Otevřít",
    items: {
      survey: {
        title: "Dotazník o servisu",
        description:
          "Vyplňte dotazník o vašem servisu a získejte atraktivní garantovanou odměnu!",
      },
      collection: {
        title: "COLLECTION",
        description:
          "Vyberte si odměny z exkluzivního katalogu produktů a propagačních předmětů značky.",
      },
      drive: {
        title: "DRIVE",
        description:
          "Získejte přístup k bohatému multimediálnímu obsahu, který vám pomůže prodávat.",
      },
      linkup: {
        title: "LINKUP",
        description:
          "Podívejte se, jak snadné je používat European customer care management.",
      },
    },
  },
  footer: {
    ariaLabel: "Patička",
    links: {
      rules: "Pravidla programu",
      contact: "Kontakt",
      cookies: "Zásady cookies",
      terms: "Obchodní podmínky",
      privacy: "Zásady ochrany osobních údajů",
      faq: "FAQ",
      e8: "E8",
    },
  },
};

export default {
  messages,
};
